import { Moment } from "moment";
import { Address } from "./LocationTypes";

export type GetPersonSummaryData = {
  personInfo: GetPersonInfoType;
  personAddresses: caregiverSummary;
  personContact: GetPersonContactType;
  preferredContactMethod: GetPreferredContactMethodType[];
};

export type GetPersonApplicationType = {
  personTypeID: number;
  webApplicationId: number;
  webApplicationName: string;
  webApplicationDesc: string;
  webApplicationIcon: string;
  webApplicationBackground: string;
  webApplicationUrl: string;
  isActive: boolean;
  personID: number;
  webApplication: string;
};

export type GetPreferredContactMethodType = {
  label: string;
  value: boolean;
  selectedValue: string;
};

type GetAddressType = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  county: string;
};

export type caregiverSummary = {
  personId: number;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  imageUrl?: string;
  imageKey?: string;
  age?: number;
  primaryLanguage: string;
  primaryPhone?: string;
  primaryPhoneAttribute?: string;
  wandaEmail: string;
  wandaEmailAddressAttribute?: string;
  homeAddress: GetAddressType;
  mailingAddress: GetAddressType;
};

export function defaultCaregiverSummary() {
  return {
    personId: 0,
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    imageUrl: "",
    age: 0,
    primaryLanguage: "",
    primaryPhone: "",
    primaryPhoneAttribute: "",
    wandaEmail: "",
    wandaEmailAddressAttribute: "",
    homeAddress: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      county: "",
    },
    mailingAddress: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      county: "",
    },
  };
}

export type GetPersonContactType = {
  homePhone: string;
  workPhone: string;
  homeEmailAddress: string;
  workEmailAddress: string;
};

type GetPersonInfoType = {
  personID: number;
  firstName: string;
  lastName: string;
  middleInitial: string;
  gender: string;
  dateOfBirth: string;
  age: number;
  primaryLanguage: string;
  email: string;
  primaryPhoneNumber: string;
};

export type UserInfo = {
  queueUserEmailId: string;
  queueUserId: Number;
  queueUserName: string;
};

export type DepotGarage = {
  locationId?: number;
  address1: string;
  address2: string;
  city: string | null;
  state: string | null;
  zip: string | null;
  latitude: number;
  longitude: number;
};

export type WandaUserInfo = {
  isMember: boolean;
  personId: number;
  profileImageUrl: string;
  clientId: string;
  reCaptchaToken: string;
  dateOfBirth: string;
  firstName: string;
  lastName: string;
  zipcode: string;
  isActive: boolean;
  personAttributes: PersonAttributes;
  imageKey: string;
  age: number;
  relation: number;
};

export type PersonAttributes = {
  homeAddress: Address;
  mailingAddress: Address;
  personContact: PersonContact;
  trustedContact: TrustedContact[];
};

export type PersonContact = {
  primaryEmailAddress: string;
  primaryPhone: string;
  wandaEmail: string;
  wandaRelation: string;
};

export type TrustedContact = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  relationship: string;
  priority: number;
  relationshipName: string;
  order: number;
  id: number;
  personAttributesKeyId: number;
  isActive: boolean;
};

export function DefaultTCData() {
  return {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    relationship: "",
    priority: 0,
    relationshipName: "",
    order: 0,
    id: 0,
    personAttributesKeyId: 0,
    isActive: true,
  };
}

export interface CustomerCareDetails {
  wandaCustomerCareNumber: string;
  wandaCustomerCareMailAddress: string;
  wandaCustomerCareTimings: string;
}

export function DefaultCustomerCareDetails() {
  return {
    wandaCustomerCareNumber: "",
    wandaCustomerCareMailAddress: "",
    wandaCustomerCareTimings: "",
  };
}

export enum PersonType {
  SomeoneElse = "someoneElse",
  Myself = "myself",
}

export type WandaAccommodations = {
  PersonAttributesKeyId: number;
  WheelChairTravel: boolean;
  WheelChairPresent: boolean;
  WCToVehicleTransfer: boolean;
};

export type PersonInitialValues = {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  relationship?: number;
  isAgeOver18?: string;
  dateOfBirth?: Moment | string;
  isSameAsHomeAddress: boolean;
  homeAddress?: Address;
  mailingAddress?: Address;
  photo?: string;
  imageKey?: string;
  wandaAccommodations: {
    wheelChairTravel: boolean;
    wheelChairPresent: boolean;
    wcToVehicleTransfer: boolean;
  };
};

export const defaultProfileInitialValues = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  relationship: 0,
  dateOfBirth: undefined,
  isSameAsHomeAddress: true,
  homeAddress: {
    fullAddress: "",
    address1: "",
    address2: null,
    city: "",
    state: "",
    county: "",
    zip: "",
  },
  mailingAddress: {
    fullAddress: "",
    address1: "",
    address2: null,
    city: "",
    state: "",
    county: "",
    zip: "",
  },
  photo: "",
  imageKey: "",
  wandaAccommodations: {
    wheelChairTravel: false,
    wheelChairPresent: false,
    wcToVehicleTransfer: false,
  },
};
